export const MAX_FREE_SEQUENCES = 2
